import { get } from 'lodash';

export const getUserStudies = state => get(state, 'studies.userStudies', []);
export const getIsStudyLaunching = state => get(state, 'studies.isStudyLaunching', false);
